import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, ListGroup } from "react-bootstrap";
import Swal from "sweetalert2";
import { Navigate, useNavigate } from "react-router-dom";
import { API_ENDPOINTS, getAuthHeaders } from "../config/api";

export default function Checkout() {
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);

  // Fetch cart items from the backend
  useEffect(() => {
    fetch(API_ENDPOINTS.ORDERS.CART_ITEMS, {
      method: "GET",
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
      if (data.success) {
        setCartItems(data.cartItems || []);
        setTotalPrice(data.totalPrice || 0);
      } else if (data.message && (data.message.toLowerCase().includes("unauthorized") || data.message.toLowerCase().includes("token"))) {
        Swal.fire({
        title: "Session Expired",
        text: "Please log in again.",
        icon: "warning",
        }).then(() => {
        localStorage.removeItem("token");
        window.location.href = "/login";
        });
      } else {
        Swal.fire({
        title: "Error",
        text: data.message || "Failed to load cart items",
        icon: "error",
        });
      }
      })
      .catch((error) => {
      console.error("Error fetching cart items:", error);
      Swal.fire({
        title: "Error",
        text: "Unable to connect to the server",
        icon: "error",
      });
      });
  }, []);

  // Handle checkout
  const navigate = useNavigate();

  const handleCheckout = () => {
    // Checkout request
    fetch(API_ENDPOINTS.ORDERS.CHECKOUT, {
      method: "POST",
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          Swal.fire("Success", "Your order has been placed!", "success");
          setCartItems([]); // Clear cart items after successful checkout
          setTotalPrice(0); // Reset total price
          navigate("/"); // Use navigate hook for redirect
        } else {
          Swal.fire("Error", data.message || "Checkout failed.", "error");
        }
      })
      .catch((error) => {
        console.error("Error during checkout:", error);
        Swal.fire("Error", "Failed to connect to the server.", "error");
      });
  };

  const handleDeleteItem = (itemId) => {
    fetch(API_ENDPOINTS.ORDERS.REMOVE_FROM_CART(itemId), {
      method: "DELETE",
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // Remove item from cartItems state and update total price
          setCartItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
          setTotalPrice((prevTotal) =>
            prevTotal -
            (cartItems.find((item) => item.id === itemId)?.price || 0)
          );
        } else {
          Swal.fire("Error", data.message || "Failed to delete item.", "error");
        }
      })
      .catch((error) => {
        console.error("Error deleting cart item:", error);
        Swal.fire("Error", "Failed to connect to the server.", "error");
      });
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col lg={{ span: 8, offset: 2 }}>
          <Card>
            <Card.Body>
              <Card.Title className="text-center">Checkout</Card.Title>
              <ListGroup variant="flush">
                {cartItems.map((item) => (
                  <ListGroup.Item key={item.id}>
                    <Row>
                      <Col xs={7}>{item.name}</Col>
                      <Col xs={3} className="text-end">
                        PhP {item.price}
                      </Col>
                      <Col xs={2} className="text-end">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDeleteItem(item.id)}
                        >
                          Delete
                        </Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
              <hr />
              <h5 className="text-end">Total: PhP {totalPrice}</h5>
              <div className="text-center mt-3">
                <Button
                  variant="primary"
                  onClick={handleCheckout}
                  disabled={cartItems.length === 0}
                >
                  Place Order
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}